var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{staticClass:"text-center",attrs:{"justify":"center"}},[_c('v-col',[_c('h1',{staticClass:"display-4 my-12 pt-12"},[_vm._v("404")]),_c('div',{staticClass:"display-3 mb-5 mt-10"},[_vm._v("Страница не найдена")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }